class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      if(event.target.name == 'sort_by'){
        document.querySelector('.sort-button strong').textContent = event.target.getAttribute('data-val');
        document.querySelector('.sort-button strong').setAttribute('data-val',event.target.value)
        const sortsOpen = document.querySelectorAll(".sort-box ul li.active");
        sortsOpen.forEach((sortOpen) => {
          sortOpen.classList.remove("active");
        });
        event.target.parentElement.classList.add('active')
        event.target.parentElement.closest('.sort-box').style.width = document.querySelector('.sort-button').offsetWidth + 'px'
        localStorage.setItem("sort", (document.querySelector('.sort-button').offsetWidth + 16));
        document.querySelector('.coll-filter-wrap').style.width = 'calc(100% - '+ (document.querySelector('.sort-button').offsetWidth+16) +'px)'
      }
      this.onSubmitHandler(event);
      // document.querySelector('body').classList.remove('open-filter','open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500);
    this.querySelector('form').addEventListener(
      'input', 
      this.debouncedOnSubmit.bind(this)
    );
    // const applyfilter = this.querySelector('.apply-filter');
    // if (applyfilter) applyfilter.addEventListener('click', this.debouncedOnSubmit.bind(this));
    const filterbtn = this.querySelector('.filter-button');
    const sortbtn = this.querySelector('.sort-button');
    if (filterbtn) filterbtn.addEventListener('click',function(e){
      let right = window.innerWidth - document.body.clientWidth
      if(document.querySelector('body').classList.contains('open-filter')){
        document.querySelector('body').style.paddingRight = ''
        document.querySelector('main').style.width = ''
      }else{
        document.querySelector('body').style.paddingRight = right+'px'
        document.querySelector('main').style.width = 'calc(100% + '+right+'px)'
      }
      document.querySelector('body').classList.toggle('open-filter');
      document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search');
      
      document.querySelector('.filter-box-inr').style.maxHeight = 'calc(100vh - '+ (document.querySelector('.snippet-collection-filter').clientHeight + document.querySelector('.clear-filter').clientHeight + 24) + 'px)'
      let announce = document.querySelector('.announcement-bar-main').clientHeight - 12
      if(window.innerWidth < 992){
        announce = document.querySelector('.announcement-bar-main').clientHeight - 8
      }
      // document.querySelector('.header-group').style.top = '-'+announce+'px';
    });    
    if (sortbtn) sortbtn.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-sort');
      document.querySelector('body').classList.remove('open-filter','open-drawer','open-menu','open-search');
      document.querySelector('.sort-box').style.width = sortbtn.offsetWidth+'px';
      localStorage.setItem("sort", (sortbtn.offsetWidth + 16));
      document.querySelector('.coll-filter-wrap').style.width = 'calc(100% - '+ (sortbtn.offsetWidth+16) +'px)'
    });
    let save = this.querySelector('.save-filter');
    if (save) save.addEventListener('click',function(e){
      document.querySelector('body').classList.remove('open-filter','open-drawer','open-menu','open-search');
    });
    if(document.querySelector('.sort-box')){
      this.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
  }
  static setListeners() {
      const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderActiveFilter(html);
        typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
        if(typeof quickAddButton == 'function'){
          quickAddButton();
        }
      });
    }
    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
    }
    static renderProductGridContainer(html) {
      document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
    }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('.filter-index');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    let count = 0;
    facetDetailsElements.forEach((filter) => {
      if(filter.classList.contains('facet-list')){
        filter.querySelectorAll('ul li.active').forEach((index,list) => {
          count++;
        });
      }
    });
    if(count > 0){
      document.querySelector('.filter-count').textContent = '(' + count + ')'
      document.querySelector('.filter-count').style.display = 'block'
    }else{
      document.querySelector('.filter-count').style.display = 'none'
    }
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
  onSubmitHandler(event) {    
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);    
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function rangePrice(params) {
  var lowerSlider = document.querySelector("#lower"),
    upperSlider = document.querySelector("#upper"),
    lowerVal = parseInt(lowerSlider.value),
    upperVal = parseInt(upperSlider.value);
  upperSlider.oninput = function () {
    lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);
    document.querySelector(".nextsetval").value = upperVal
    document.querySelector(".prevtsetval").value = lowerVal
    if (upperVal < lowerVal + 4) {
      lowerSlider.value = upperVal - 4;
      if (lowerVal == lowerSlider.min) {
        upperSlider.value = 4;
      }
    }
    let rr_slider = document.querySelector(".price-right");
    let rr_val = rr_slider.value;
    let rr_width = rr_slider.clientWidth - 15;
    let rr_min = rr_slider.getAttribute("min");
    let rr_max = rr_slider.getAttribute("max");
    let rr_percent = ((rr_val - rr_min) / (rr_max - rr_min)) * 100;
    let rr_offset = -3;
    let rr_newPosition = rr_width * rr_percent + rr_offset;
    // document.querySelector('.r_range_position').style.left = rr_newPosition;
  };
  lowerSlider.oninput = function () {
    lowerVal = parseInt(lowerSlider.value);
    upperVal = parseInt(upperSlider.value);
    document.querySelector(".prevtsetval").value = lowerVal
    document.querySelector(".nextsetval").value = upperVal
    if (lowerVal > upperVal - 4) {
      upperSlider.value = lowerVal + 4;
      if (upperVal == upperSlider.max) {
        lowerSlider.value = parseInt(upperSlider.max) - 4;
      }
    }
    let rl_slider = document.querySelector(".price-left");
    let rl_val = rl_slider.value;
    let rl_width = rl_slider.clientWidth - 15;
    let rl_min = rl_slider.getAttribute("min");
    let rl_max = rl_slider.getAttribute("max");
    let rl_percent = ((rl_val - rl_min) / (rl_max - rl_min)) * 100;
    let rl_offset = -3;
    let rl_newPosition = rl_width * rl_percent + rl_offset;
    // document.querySelector('.l_range_position').style.left = rl_newPosition;
  };
  document.querySelector(".prevtsetval").addEventListener('change',function(){
    document.querySelector(".price-left").value = this.value
    rangePrice();
  });
  document.querySelector(".nextsetval").addEventListener('change',function(){
    document.querySelector(".price-right").value = this.value
    rangePrice();
  });
  document.querySelector(".prevtsetval").addEventListener('keyup',function(){
    document.querySelector(".price-left").value = this.value
    rangePrice();
  });
  document.querySelector(".nextsetval").addEventListener('keyup',function(){
    document.querySelector(".price-right").value = this.value
    rangePrice();
  });
}
if(document.querySelector(".rangecls")){
  rangePrice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect()
addEventListener("DOMContentLoaded", (event) => {
  if(localStorage.getItem("sort") != null){
    document.querySelector('.coll-filter-wrap').style.width = 'calc(100% - '+ (parseInt(localStorage.getItem("sort"))+16) +'px)'
  }
});
$(document).on('click', 'body', function(e){
  var tag = $('.sort-box.filterwrap,.sort-button');
  if (!tag.is(e.target) && tag.has(e.target).length === 0) {
    $('body').removeClass('open-sort')
  }
});